import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthenticationProvider } from './contexts/AuthenticationProvider';
import ProtectedRoute from './components/ProtectedRoute';

import Login from './pages/Login';
import { ActiveTrials } from './pages/ActiveTrials';
import { ExpiredTrials } from './pages/ExpiredTrials';
import {AccountDetails} from "./pages/AccountDetails";

const App: React.FC = () => {
    return (
        <AuthenticationProvider>
            <Router>
                <Routes>
                    {/* Redirect root to trials or login */}
                    <Route path="/" element={<Navigate to="/trials" replace />} />

                    {/* Public routes */}
                    <Route path="/login" element={<Login />} />

                    {/* Protected routes - admin only */}
                    <Route element={<ProtectedRoute requiredRole="admin" />}>
                        <Route path="/dashboard" element={<Navigate to="/trials" replace />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredRole="admin" />}>
                        <Route path="/trials" element={<ActiveTrials />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredRole="admin" />}>
                        <Route path="/expired-trials" element={<ExpiredTrials />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredRole="admin" />}>
                        <Route path="/account/:storeUrl" element={<AccountDetails />} />
                    </Route>
                </Routes>
            </Router>
        </AuthenticationProvider>
    );
};

export default App;
